import { Injectable } from '@angular/core';
import { loadGapiInsideDOM } from 'gapi-script';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class GoogleAuthService {
  private gapiLoaded: boolean = false;

  private googleSignInRes = new BehaviorSubject<any>('');
  googleSignInData = this.googleSignInRes.asObservable();

  private googleSignInResLoading = new BehaviorSubject<any>(false);
  googleSignInLoading = this.googleSignInResLoading.asObservable();

  private google_client_id = '136466974291-g37cvkbiqv5sdgqtdvpcgvvmldeujgf8.apps.googleusercontent.com';

  loading : boolean = false;

  constructor() {
    this.initializeGapi();
  }

  updateGoogleSignInRes(value) {
    this.googleSignInRes.next(value);
  }

  private initializeGapi() {
    loadGapiInsideDOM().then(() => {
      gapi.load('auth2', () => {
        gapi.auth2.init({
          client_id: this.google_client_id,
          scope: 'profile email'
        }).then(() => {
          this.gapiLoaded = true;
          console.log('GAPI client initialized');
        }).catch(error => {
          console.error('Error while GAPI client initializing', error);
        });
      });
    });
  }

  googleSignIn() {
    if (this.gapiLoaded) {
      this.loading = true;
      const GoogleAuth = gapi.auth2.getAuthInstance();

      GoogleAuth.signIn().then(user => {

        const user_data: any = {
          user_id_token: user.getAuthResponse()?.id_token ?? '',
          user_email: user.getBasicProfile()?.getEmail(),
          profile_id: user.getBasicProfile()?.getId(),
          google_client_id: this.google_client_id
        };

        this.googleSignInRes.next(user_data);
        this.loading = false;
      }).catch(error => {
        console.error('Error signing in', error);
        this.googleSignInRes.next(error);
        this.loading = false;
      });
    } else {
      console.error('GAPI client not initialized');
      this.googleSignInRes.next({ error: 'GAPI client not initialized' });
      this.loading = false;
    };
    this.googleSignInResLoading.next(this.loading);
  }

  googleSignOut() {
    const GoogleAuth = gapi.auth2.getAuthInstance();
    GoogleAuth.signOut().then(() => {
      console.log('User signed out.');
    });
  }
}
